import { FunctionComponent, memo } from "react";
import { IProps } from "./date-indicator.types";
import "./date-indicator.scss";

/**
 * Show the date a message was send above a chat message.
 * @param props.date The date to display.
 * @returns Displays a date in the format Monday, 1st January.
 */
const DateIndicator: FunctionComponent<IProps> = ({ date }) => (
    <>
        <div className="date-indicator__line" />
        <div className="date-indicator__date__container">
            <div className="date-indicator__date">{date}</div>
        </div>
    </>
);

export default memo(DateIndicator);
